import { sdk } from '../sdk';

export interface ExpenseType {
  _id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateExpenseTypeData {
  name: string;
}

export interface UpdateExpenseTypeData {
  name?: string;
  isActive?: boolean;
}

export interface ExpenseTypeResponse {
  success: boolean;
  data: ExpenseType;
}

export interface ExpenseTypesResponse {
  success: boolean;
  data: ExpenseType[];
}

export const ExpenseTypesAPI = {

  async getAllExpenseTypes(): Promise<ExpenseType[]> {
    const response = await sdk.client.get('/api/v1/expense-types');
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async getActiveExpenseTypes(): Promise<ExpenseType[]> {
    const response = await sdk.client.get('/api/v1/expense-types/active');
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async getExpenseTypeById(id: string): Promise<ExpenseType> {
    const response = await sdk.client.get(`/api/v1/expense-types/${id}`);
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async createExpenseType(data: CreateExpenseTypeData): Promise<ExpenseTypeResponse> {
    const response = await sdk.client.post('/api/v1/expense-types', data);
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async updateExpenseType(id: string, data: UpdateExpenseTypeData): Promise<ExpenseTypeResponse> {
    const response = await sdk.client.put(`/api/v1/expense-types/${id}`, data);
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async toggleExpenseTypeStatus(id: string): Promise<ExpenseTypeResponse> {
    const response = await sdk.client.patch(`/api/v1/expense-types/${id}/toggle-status`);
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  },

  async deleteExpenseType(id: string): Promise<{ success: boolean; message: string }> {
    const response = await sdk.client.delete(`/api/v1/expense-types/${id}`);
    // Handle both wrapped and unwrapped responses
    return response.data || response;
  }
};
